import React from 'react';
import BaseComponent from './BaseComponent';
import Entries from './Entries';
import {connect} from 'react-redux';

class PureFavouritesList extends BaseComponent {
    render() {
        const {favourites} = this.props;

        return <Entries showDates={true} favourites={favourites} />;
    }
}

function mapStateToProps({app}) {
    return {
        favourites: app.getIn(['user', 'favourites']),
    };
}

export default connect(mapStateToProps)(PureFavouritesList);



/** WEBPACK FOOTER **
 ** ./src/components/FavouritesList.jsx
 **/